<template>
  <div class="flex flex-col h-full overflow-hidden">
    <!-- Progress Indicator -->
    <report-progress :showProgress="isLoading" />

    <!-- Table Container with Sticky Header -->
    <div class="flex-1 overflow-hidden">
      <div class="h-full flex flex-col">
        <!-- Single Table with Sticky Header -->
        <div class="flex-1 overflow-auto">
          <table class="w-full table-auto text-sm">
            <thead class="sticky top-0 z-10">
              <tr>
                <th class="!bg-primary-900 text-white set-border text-center font-weight-medium rounded-s-lg px-2 py-2">
                  {{ $t("reports.system_inbound_report.date") }}
                </th>
                <th class="!bg-primary-900 text-white set-border text-center font-weight-medium rounded-e-lg px-2 py-2">
                  {{ $t("reports.system_inbound_report.head_Inbound") }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(record, index) in reportData" :key="record.dateonly" 
                  :class="index % 2 === 0 ? 'bg-white' : 'bg-gray-50'">
                <td class="text-center px-2 py-2 border-b border-gray-200">
                  {{ record.dateonly }}
                </td>
                <td class="text-center px-2 py-2 border-b border-gray-200">
                  {{ formatNumber(record.total) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReportProgress from "../../components/ReportProgress.vue";
import { formatArabicDate, formatNumber } from "../../utils";

export default {
  name: "system-inbound-report",
  components: {
    ReportProgress,
  },
  props: {
    selectedFilters: {
      type: Object,
      default: () => ({})
    },
    skills: {
      type: Array,
      default: () => []
    },
    reportData: {
      type: Array,
      default: () => []
    },
    totalCount: {
      type: Number,
      default: 0
    },
    showCount: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    formatNumber(num) {
      const lang = this.$i18n.locale;
      return formatNumber(num, lang);
    },
    
    formatDate(date) {
      const lang = this.$i18n.locale;
      return formatArabicDate(date, lang);
    },
  },
  computed: {
    currentLocal() {
      return this.$i18n.locale;
    },
  },
};
</script>

<style scoped>
.set-border {
  border: 2px solid #d7eaf3;
}
</style>
